const blogList = [
  {
    id: '1',
    date: '15',
    month: 'July',
    image: 'assets/images/blog/01.png',
    comments: '131',
    views: '255',
    title: 'Bootsland Perfect Performance landing Page',
    category: 'Sass',
  },
  {
    id: '2',
    date: '15',
    month: 'July',
    image: 'assets/images/blog/02.png',
    comments: '131',
    views: '255',
    title: 'The most powerful template that makes you.',
    category: 'Marketing',
  },
  {
    id: '3',
    date: '15',
    month: 'July',
    image: 'assets/images/blog/03.png',
    comments: '131',
    views: '255',
    title: 'A brand for a company is like a reputation person.',
    category: 'Landing',
  },
  {
    id: '4',
    date: '15',
    month: 'July',
    image: 'assets/images/blog/02.png',
    comments: '131',
    views: '255',
    title: 'The most powerful template that makes you.',
    category: 'Marketing',
  },
];

export default blogList;
